import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCustomerDeposits, createCustomerDeposit, updateCustomerDeposit } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetCustomerDeposits = (tranId, enabled = true) => {
  return useQuery({
    queryKey: ["customer-deposits", tranId],
    queryFn: () => getCustomerDeposits(tranId),
    enabled: !!tranId && enabled,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};

export const useCreateCustomerDeposit = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: (data) => createCustomerDeposit(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["customer-deposits"] });
      showNotification('success', 'Deposit posted successfully!');
    },
    onError: (error) => {
      console.error("Error creating customer deposit:", error);
      
      let errorMessage = 'Error posting deposit. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      showNotification('danger', errorMessage);
    },
  });
};

export const useUpdateCustomerDeposit = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: ({ tranId, data }) => updateCustomerDeposit(tranId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["customer-deposits"] });
      showNotification('success', 'Deposit refunded successfully!');
    },
    onError: (error) => {
      console.error("Error updating customer deposit:", error);
      
      let errorMessage = 'Error refunding deposit. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      showNotification('danger', errorMessage);
    },
  });
};

